import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Checkbox, MaskedField, TextField } from '@/components/forms';
import { OnboardingLayout } from '@/components/layout';
import { useSession } from '@/features/auth/session/context';

/**
 * Cadastro inicial do negócio — fiel a design/html/onboarding.html. A conta é criada antes, em
 * /cadastro; os dados do negócio ainda não são salvos (#13) e o envio só navega para o checkout.
 */
export function OnboardingPage() {
  const navigate = useNavigate();
  const session = useSession();
  const viewerEmail = session.status === 'ready' ? session.viewer?.email : undefined;
  const [cnpj, setCnpj] = useState('');
  const [terms, setTerms] = useState(false);
  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!terms) {
      alert('Aceite os termos de uso para continuar.');
      return;
    }
    navigate('/checkout');
  };
  return (
    <OnboardingLayout steps={['Criar conta', 'Dados do negócio', 'Configurar pagamentos']} current={0}>
      <h1>Comece a receber com a Lisboon</h1>
      <p className="lead">Configure seu checkout em poucos minutos.</p>
      <form id="ob" noValidate onSubmit={onSubmit}>
        <TextField id="n" label="Nome do negócio" required placeholder="Ex.: Loja Exemplo" autoComplete="organization" />
        <MaskedField id="c" label="CNPJ" mask="cnpj" value={cnpj} onChange={setCnpj} required />
        <TextField id="e" label="E-mail profissional" type="email" required placeholder="seuemail@seudominio.com.br" autoComplete="email" defaultValue={viewerEmail} key={viewerEmail ?? 'demo'} />
        <Checkbox wrapperClassName="terms" id="t" required checked={terms} onChange={(e) => setTerms(e.target.checked)} label={<>Aceito os <a className="lnk" style={{ fontSize: 'inherit' }} href="#">termos de uso</a></>} />
        <Button block type="submit">Continuar</Button>
      </form>
    </OnboardingLayout>
  );
}
